import{ComponentDefaultTestId as t}from"./constants.js";var n=t,o=function(t,n){var o=null!=n?n:"";return"".concat(t).concat(o&&"_".concat(o))};export{n as ComponentDefaultTestId,o as getTestId};
